import React, { useState } from 'react';
import { Bot, CheckSquare, Send, MoreHorizontal } from 'lucide-react';
import { useApp } from '../context/AppContext';

const Workspace = () => {
    const { getActiveBusiness } = useApp();
    const business = getActiveBusiness();
    const [chatInput, setChatInput] = useState('');

    return (
        <div className="h-[calc(100vh-6rem)] flex flex-col md:flex-row gap-6">
            {/* Left: Operational Board */}
            <div className="flex-1 flex flex-col gap-6 overflow-y-auto pr-2">
                <header>
                    <h1 className="text-2xl font-bold text-slate-900">{business.name} <span className="text-slate-400 font-normal">/ Workspace</span></h1>
                    <div className="flex gap-4 mt-4">
                        <div className="card px-4 py-3 flex-1">
                            <p className="text-xs text-slate-500 uppercase font-bold">Revenue</p>
                            <p className="text-xl font-bold">{business.revenue}</p>
                        </div>
                        <div className="card px-4 py-3 flex-1">
                            <p className="text-xs text-slate-500 uppercase font-bold">Stage</p>
                            <p className="text-xl font-bold text-primary">{business.stage}</p>
                        </div>
                    </div>
                </header>

                {/* Tasks Module */}
                <div className="card flex-1 flex flex-col">
                    <div className="p-4 border-b border-border flex justify-between items-center">
                        <h3 className="font-bold flex items-center gap-2"><CheckSquare size={18} /> Priority Tasks</h3>
                        <button className="text-primary text-sm font-medium">+ Add Task</button>
                    </div>
                    <div className="p-2 space-y-1">
                        {business.tasks.map(task => (
                            <div key={task.id} className="flex items-center gap-3 p-3 hover:bg-slate-50 rounded-lg group">
                                <input type="checkbox" className="w-4 h-4 text-primary rounded border-slate-300 focus:ring-primary" defaultChecked={task.status === 'done'} />
                                <span className={`flex-1 text-sm ${task.status === 'done' ? 'line-through text-slate-400' : 'text-slate-700'}`}>{task.title}</span>
                                <button className="opacity-0 group-hover:opacity-100 text-slate-400"><MoreHorizontal size={16} /></button>
                            </div>
                        ))}
                        <div className="p-3 text-slate-400 text-sm italic">Syncing with Asana...</div>
                    </div>
                </div>
            </div>

            {/* Right: AI Co-Founder */}
            <div className="w-full md:w-96 card flex flex-col shadow-xl border-indigo-100">
                <div className="p-4 border-b border-border bg-indigo-600 text-white rounded-t-xl flex items-center gap-3">
                    <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center"><Bot size={18} /></div>
                    <div>
                        {/* NAME UPDATE */}
                        <h3 className="font-bold text-sm">AutoInventor AI</h3>
                        <p className="text-xs opacity-80">Always Online</p>
                    </div>
                </div>

                <div className="flex-1 bg-slate-50 p-4 space-y-4 overflow-y-auto">
                    <div className="flex justify-start">
                        <div className="bg-white border border-border p-3 rounded-2xl rounded-tl-none text-sm shadow-sm max-w-[85%]">
                            I've drafted the Q3 growth strategy for {business.name}. Would you like to review the marketing budget?
                        </div>
                    </div>
                    <div className="flex justify-end">
                        <div className="bg-primary text-white p-3 rounded-2xl rounded-tr-none text-sm shadow-sm max-w-[85%]">
                            Yes, show me the paid ads allocation.
                        </div>
                    </div>
                </div>

                <div className="p-3 border-t border-border bg-white rounded-b-xl">
                    <form className="relative" onSubmit={(e) => { e.preventDefault(); setChatInput(''); }}>
                        <input
                            className="w-full pl-4 pr-10 py-3 bg-slate-50 border border-border rounded-xl text-sm focus:outline-none focus:border-primary"
                            placeholder="Ask AutoInventor to do something..."
                            value={chatInput}
                            onChange={e => setChatInput(e.target.value)}
                        />
                        <button type="submit" className="absolute right-2 top-2 p-1.5 text-primary hover:bg-indigo-50 rounded"><Send size={16} /></button>
                    </form>
                </div>
            </div>
        </div>
    );
};
export default Workspace;
